import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07723b18"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "shop-finally shop-main"
}
const _hoisted_2 = { class: "shop-form" }
const _hoisted_3 = { class: "phase" }
const _hoisted_4 = { class: "phasetop" }
const _hoisted_5 = { class: "phasename" }
const _hoisted_6 = { class: "load" }
const _hoisted_7 = {
  key: 0,
  class: "shop-form__block _failed-payment"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "К сожалению, оплата не прошла", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Заказ не был успешно завершен. Пожалуйста, попробуйте снова.", -1))
const _hoisted_10 = { class: "shop-form__block" }
const _hoisted_11 = { class: "text3" }
const _hoisted_12 = { class: "text2" }
const _hoisted_13 = { class: "text2" }
const _hoisted_14 = { class: "text2" }
const _hoisted_15 = {
  key: 1,
  class: "shop-form__block"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text3" }, "Покупатель:", -1))
const _hoisted_17 = { class: "text2" }
const _hoisted_18 = { class: "text2" }
const _hoisted_19 = { class: "text2" }
const _hoisted_20 = { class: "expiration-date" }
const _hoisted_21 = { class: "time" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { class: "price" }
const _hoisted_24 = {
  key: 2,
  class: "button next",
  href: "https://tekstura.moscow/"
}

import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import getExpirationStringForCertificate from "@/functions/getExpirationStringForCertificate";
import getExpirationStringForAbonement from "@/functions/getExpirationStringForAbonement";


export default /*#__PURE__*/_defineComponent({
  __name: 'shop-payStatus',
  setup(__props) {

const store = useStore();

const route = useRoute();
const paymentStatus = computed(() => route.query.pay);

const loyalityTypes = computed(() => store.state.allLoyalityTypes);

const isOther = computed(() => !!currentPagePayment.value.Data.BuyerPhone);
const isSentToSelf = computed(() => currentPagePayment.value.Data.SendTo === 'self');

const currentPagePayment = computed(() => store.state.currentPagePayment);

const currentDesing = computed(() => store.state.allDesignTypes.find(i => i.id === currentPagePayment.value.design_id))

const currentLoyalityKind = computed(() => currentPagePayment.value.type);

const currentBuyLoyality = computed(() => {
  const currentBuy = [
    ...loyalityTypes.value.certificates,
    ...loyalityTypes.value.abonements,
  ].find((i) => i.id === currentPagePayment.value.currentLoyality.id);

  const expiration =
    currentPagePayment.value.type === "certificate"
      ? getExpirationStringForCertificate(currentBuy)
      : getExpirationStringForAbonement(currentBuy);

  return {
    type: currentBuy,
    expiration: expiration,
  };
});

const titleStr = computed(() => {
  return currentBuyLoyality.value.type.title.replace(/\//g, '|');
})

const titleText = computed(() => {
  const text1 = "Отправлен на вашу почту";
  const text2 = "Отправлен вам для самостоятельного вручения";
  const text3 = "Отправлен будущему владельцу";
  const text4 = "Будет отправлен на вашу почту после успешной оплаты";
  const text5 =
    "Будет отправлен вам для самостоятельного вручения после успешной оплаты";
  const text6 = "Будет отправлен будущему владельцу после успешной оплаты";

  const status = paymentStatus.value;

  if (status === "success") {
    if (isOther.value) {
      if (isSentToSelf.value) {
        return text2;
      } else {
        return text3;
      }
    } else {
      return text1;
    }
  } else {
    if (isOther.value) {
      if (isSentToSelf.value) {
        return text5;
      } else {
        return text6;
      }
    } else {
      return text4;
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (currentPagePayment.value.type)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "shop-main__card active",
          style: _normalizeStyle({
        background: `url(${currentDesing.value.image}) no-repeat center / cover`,
      })
        }, [
          _createElementVNode("span", null, _toDisplayString(currentLoyalityKind.value === "certificate" ? "Сертификат" : "Абонемент"), 1)
        ], 4),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(paymentStatus.value === "success"
              ? "Успешно оформлен и оплачен"
              : "Не оплачен"), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                style: _normalizeStyle([{"width":"100%"}, {
              'background-color':
                paymentStatus.value === 'success' ? '#6CA475' : '#E4C09E',
            }])
              }, null, 4)
            ])
          ]),
          (paymentStatus.value === 'failed')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createElementVNode("div", {
                  class: _normalizeClass(
        _unref(store).state.isPaymentLoader ? '_loader _loader-40px ' : ''
      )
                }, [
                  _createElementVNode("a", {
                    class: "button next",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).dispatch('rePayment')))
                  }, "Оплатить")
                ], 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(titleText.value), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(currentPagePayment.value.Data.Name), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(currentPagePayment.value.Data.Phone), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(currentPagePayment.value.Data.Email), 1)
          ]),
          (isOther.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, _toDisplayString(currentPagePayment.value.Data.BuyerName), 1),
                _createElementVNode("div", _hoisted_18, _toDisplayString(currentPagePayment.value.Data.BuyerEmail), 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(currentPagePayment.value.Data.BuyerPhone), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, [
              _createTextVNode(_toDisplayString(titleStr.value) + " ", 1),
              _hoisted_22,
              _createTextVNode(_toDisplayString(currentBuyLoyality.value.expiration), 1)
            ]),
            _createElementVNode("span", _hoisted_23, _toDisplayString(currentLoyalityKind.value === "certificate"
              ? currentBuyLoyality.value.type.balance.toLocaleString()
              : currentBuyLoyality.value.type.cost.toLocaleString()) + " ₽", 1)
          ]),
          (paymentStatus.value === 'success')
            ? (_openBlock(), _createElementBlock("a", _hoisted_24, "Перейти на главную"))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})